import {DropdownMenuItem, styled} from "@reside/ui";

export const StyledDropdownMenuItem = styled(DropdownMenuItem)`
  &:hover {
    opacity: 1;
    background-color: ${({theme}) => theme.color.lightBlue10};
  }
`;
